import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  StorageOccupancyRow,
  firstExpandableOccupancyId,
} from '@app/pages/admin/orchestration-storage-occupancy.util';

@Component({
  selector: 'app-orchestration-storage-occupancy',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './orchestration-storage-occupancy.html',
  styleUrl: './orchestration-storage-occupancy.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationStorageOccupancyComponent {
  readonly heading = input('');
  readonly rows = input<StorageOccupancyRow[]>([]);
  readonly objectCount = input<number | null>(null);

  readonly openId = computed(() => firstExpandableOccupancyId(this.rows()));
}
